import React from 'react'
import LegalPage from '../comps/legalPage'

const Policy = () => (
  <LegalPage
    title="Privacy policy"
    heading="Privacy policy"
    description="Read how Pinweelo collects, uses, and protects account, content, and usage information."
  >
    <div className="legalHeroShot legalRise">
      <img
        alt="Office workspace"
        src="https://images.pexels.com/photos/380769/pexels-photo-380769.jpeg?auto=compress&cs=tinysrgb&w=1600"
      />
      <div>
        <h2>Privacy policy</h2>
        <p>
          We take your privacy seriously, whether you have an account or you are only browsing. This page explains what we collect and why.
        </p>
      </div>
    </div>

    <article className="legalSplit legalRise">
      <img alt="Laptop with lock on the screen" src="https://images.pexels.com/photos/60504/security-protection-anti-virus-software-60504.jpeg?auto=compress&cs=tinysrgb&w=1200" />
      <div>
        <h3>What we collect</h3>
        <ul>
          <li>Account details you give us: email, name, password, profile photo, and bio.</li>
          <li>Content you post: videos, photos, comments, messages, and rooms.</li>
          <li>Activity needed to run the app: views, likes, follows, and basic device information.</li>
        </ul>
      </div>
    </article>

    <article className="legalSplit legalSplitFlip legalRise">
      <img alt="Hands typing on a keyboard" src="https://images.pexels.com/photos/844297/pexels-photo-844297.jpeg?auto=compress&cs=tinysrgb&w=1200" />
      <div>
        <h3>How we use it</h3>
        <p>
          We use this information to run your account, show your posts, recommend content, send notifications you asked for, and keep Pinweelo secure. We do not sell your personal information.
        </p>
      </div>
    </article>

    <article className="legalSplit legalRise">
      <img alt="Person reviewing a screen" src="https://images.pexels.com/photos/2531709/pexels-photo-2531709.jpeg?auto=compress&cs=tinysrgb&w=1200" />
      <div>
        <h3>Who can see it</h3>
        <p>
          Public posts can be seen by anyone on Pinweelo. Messages and private profile details stay between you and the people you share them with. Staff may review reports when someone breaks the rules or we need to protect the service.
        </p>
      </div>
    </article>

    <article className="legalSplit legalSplitFlip legalRise">
      <img alt="Light through glass" src="https://images.pexels.com/photos/1109543/pexels-photo-1109543.jpeg?auto=compress&cs=tinysrgb&w=1200" />
      <div>
        <h3>Your choices</h3>
        <p>
          You can update your profile in Settings. To ask a privacy question or request account deletion, use the Contact us page. Built in 2021, Pinweelo is designed so your trust stays part of how we build the product.
        </p>
      </div>
    </article>

    <div className="legalGallery legalRise">
      <img alt="Phone in someone’s hands" src="https://images.pexels.com/photos/4144179/pexels-photo-4144179.jpeg?auto=compress&cs=tinysrgb&w=900" />
      <img alt="Server lights" src="https://images.pexels.com/photos/325229/pexels-photo-325229.jpeg?auto=compress&cs=tinysrgb&w=900" />
      <img alt="Writing notes" src="https://images.pexels.com/photos/590022/pexels-photo-590022.jpeg?auto=compress&cs=tinysrgb&w=900" />
    </div>
  </LegalPage>
)

export default Policy
